import { useEffect, useRef } from 'react';

export function useDismissible<T extends HTMLElement>(onRequestDismissal: () => void) {
  const ref = useRef<T>(null);
  useEffect(() => {
    const handleClickOutside = (event: globalThis.MouseEvent) => {
      if (event.target instanceof Element && ref.current && !ref.current.contains(event.target)) {
        onRequestDismissal();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onRequestDismissal, ref]);
  return { ref };
}
